import { calculateDistance } from '@/utils/locationUtils';

const METERS_PER_MILE = 1609.344;

/** Walk stays available at 50 km and is hidden only past that. */
export const WALK_MAX_KILOMETERS = 50;

export type GoogleTravelMode = 'walking' | 'driving' | 'bicycling' | 'transit';

export interface RoutePoint {
  lat: number;
  lng: number;
}

export function routeDistanceMeters(origin: RoutePoint, destination: RoutePoint): number {
  return calculateDistance(
    { lat: Number(origin.lat), lng: Number(origin.lng) },
    { lat: Number(destination.lat), lng: Number(destination.lng) }
  );
}

export function shouldOfferWalk(distanceMeters: number): boolean {
  return distanceMeters / 1000 <= WALK_MAX_KILOMETERS;
}

/** Drive until Walk, Bike, or Transit is chosen. Walk falls back to Drive past 50 km. */
export function resolveTravelMode(
  chosen: GoogleTravelMode | null | undefined,
  distanceMeters: number | null
): GoogleTravelMode {
  if (chosen === 'walking' && distanceMeters != null && !shouldOfferWalk(distanceMeters)) {
    return 'driving';
  }
  if (chosen === 'driving' || chosen === 'walking' || chosen === 'bicycling' || chosen === 'transit') {
    return chosen;
  }
  return 'driving';
}

function formatAmount(value: number): string {
  if (value >= 100) return value.toFixed(0);
  if (value >= 10) return value.toFixed(1);
  return value.toFixed(2);
}

/** Straight-line distance in both units, shown under the destination card. */
export function formatRouteDistance(distanceMeters: number): string {
  const miles = distanceMeters / METERS_PER_MILE;
  const kilometers = distanceMeters / 1000;
  return `${formatAmount(miles)} miles · ${formatAmount(kilometers)} kilometers`;
}

export function googleMapsDirectionsUrl(
  origin: RoutePoint,
  destination: RoutePoint,
  travelmode: GoogleTravelMode
): string {
  return `https://www.google.com/maps/dir/?api=1&origin=${origin.lat},${origin.lng}&destination=${destination.lat},${destination.lng}&travelmode=${travelmode}`;
}
